import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogModule, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../../../../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../../../../helper/helper';
import { getErrorMessage } from '../../../../../helper/validation.helper';
import { NumberTransformInputComponent } from '../../../../../number-transform-input/number-transform-input.component';
import { arlBaseCostAllowanceFormGroup, getARLBaseCostAllowanceForm } from '../../arl-form-data.service';
import { ArlChargeDialogBase } from '../arl-charge-dialog/ArlChargeDialogBase';
import {
    AccountsReceivableLedgerTypeEnum
} from '../../../../../dave-data-module/entities/accounts-receivable-ledger.entity';

export type ArlAllowanceDialogComponentDialogReturnData = undefined;
export interface ArlAllowanceDialogComponentDialogData {
    arlAllowanceFormArray: FormArray<arlBaseCostAllowanceFormGroup>;
}
@Component({
    selector: 'app-arl-allowance-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FontAwesomeModule,
        MatLegacyFormFieldModule,
        NumberTransformInputComponent,
        FormsModule,
        MatLegacyInputModule,
        MatLegacyListModule,
        MatLegacyButtonModule,
        MatLegacyTooltipModule,
        ReactiveFormsModule,
        MatLegacyDialogModule,
        AppButtonModule,
    ],
    templateUrl: './arl-allowance-dialog.component.html',
    styleUrls: ['./arl-allowance-dialog.component.scss'],
})
export class ArlAllowanceDialogComponent extends ArlChargeDialogBase {
       protected filterAllowanceCharges(form: arlBaseCostAllowanceFormGroup): boolean {
        return  !form.value.arlType && (form.value.percent || 0) <= 0
    }
    constructor(@Inject(MAT_DIALOG_DATA) dialogData: ArlAllowanceDialogComponentDialogData) {
        super(dialogData.arlAllowanceFormArray);
    }
    addClick() {
        this.add(getARLBaseCostAllowanceForm(
            {
                title: null,
                percent: null,
                arlType: null,
            },
            'allowance'
        ));
    }
}
